import { useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { PCIRegisterReportValidate } from '../../../config/Validate';
import { APP_BASE_URL, REGPREFIX } from '../../../appconfig/Settings';
import { postAllData } from '../../../service/ProductService';
import { DOWNLOADPCIREGISTER } from '../../../config/ApiConstant';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';

export const PCIRegisterReport = () => {
    document.title = 'PCI Register | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    //Loading/Page Loading
    const [errors, setErrors] = useState<any>({});
    const [regDetails, setRegDetails] = useState<any>({});
    const [showLoading, setShowLoading] = useState<boolean>(false);

    const [selectedRegPrefix, setSelectedRegPrefix] = useState<any>(null);

    const handleChange = (e: any, name: string) => {
        let val = (e.target && e.target.value) || e.value || '';

        setRegDetails({ ...regDetails, [name]: val });
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <div>
                    <label htmlFor="name">Year</label>
                    <div className="input-effect-div mt-1">
                        <InputText
                            keyfilter={'num'}
                            maxLength={4}
                            minLength={4}
                            value={regDetails?.year}
                            style={{ minWidth: '300px' }}
                            name="year"
                            autoComplete="off"
                            placeholder="Enter Year"
                            onChange={(e) => handleChange(e, 'year')}
                            className={errors['year'] && 'p-invalid'}
                        />
                        <span className="focus-bg"></span>
                    </div>

                    <small className="p-invalid-txt">{errors['year']}</small>
                </div>

                <div className="ml-4">
                    <label htmlFor="prefix">Registration Prefix</label>
                    <div className="input-effect-div mt-1">
                        <Dropdown
                            value={selectedRegPrefix}
                            name="application"
                            options={REGPREFIX}
                            filter
                            optionLabel="name"
                            placeholder="Select Option"
                            onChange={(e) => setSelectedRegPrefix(e.value)}
                            className={errors['application'] && 'p-invalid '}
                            style={{ minWidth: '300px' }}
                        />
                    </div>
                    <small className="p-invalid-txt">{errors['application']}</small>
                </div>

                <Button label="Download" onClick={() => getPCIReport()} loading={showLoading} className="ml-4 mt-4"></Button>
            </>
        );
    };

    // getPCIReportList
    const getPCIReport = async () => {
        try {
            const { errors, isError } = PCIRegisterReportValidate(regDetails, selectedRegPrefix);
            setErrors(errors);
            if (!isError) {
                setShowLoading(true);

                // Request Data
                const requestData = {
                    year: regDetails?.year,
                    option: selectedRegPrefix?.code,
                    type: 'pci'
                };

                const response = await postAllData(DOWNLOADPCIREGISTER, requestData);

                if (response?.success) {
                    setShowLoading(false);
                    //CSV Download
                    const link = document.createElement('a');
                    link.href = APP_BASE_URL + '/csv/Pci_Register_Report.csv';
                    link.target = '_blank';
                    document.body.appendChild(link);
                    link.click();
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setShowLoading(false);

                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    return (
        <>
             <AppBreadcrumb currentMenu={'Reports'} pageName={'PCI Register Report'} pageTitle={'PCI Register Report'} goToPage={true} />

            <Toast ref={toast} />
            <div className="grid crud-demo mt-2 pci-register">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate}></Toolbar>
                    </div>
                </div>
            </div>
        </>
    );
};
